import * as S from './styles';

import Icon from '@svgIcons/dashboard/descending.svg';

export default {
    name: 'DropdownSelectedBox',
    props: {
        className: {
            type: String,
            default: '',
        },
        selectedOption: {
            type: String | Number | Array,
        },
        translator: {
            type: Function,
            default: R.identity,
        },
        customArrowIcon: {
            type: Object,
            default: null,
        },
        isMultiple: {
            type: Boolean,
            default: false,
        },
        allowEmptyValue: {
            type: Boolean,
            default: false,
        },
        id: { type: String, default: '' },
        customItemRenderer: Function,
        placeholder: String | Object,
        disabled: { type: Boolean, default: false },
        tooltipGenerator: {
            type: Function,
            default: R.always(''),
        },
        maxWidth: undefined,
        uiDisabled: { type: Boolean, default: false },
        isOpen: {
            type: Boolean,
            default: false,
        },
        arrowIconVisible: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        // 0 is a valid selection (e.g. attribution window "0 days"); only
        // nil/'' count as empty.
        hasSelectedValue() {
            return (this.selectedOption ?? '') !== '';
        },
    },

    render() {
        const {
            className,
            customArrowIcon,
            id,
            allowEmptyValue,
            selectedOption,
            translator,
            customItemRenderer,
            placeholder,
            disabled,
            tooltipGenerator,
            maxWidth,
            uiDisabled,
            isOpen,
            arrowIconVisible,
            hasSelectedValue,
        } = this;

        const getText = () => {
            const allowEmptyText = allowEmptyValue && !hasSelectedValue;

            if (allowEmptyText) {
                return translator ? translator('') : '';
            } else {
                return hasSelectedValue
                    ? customItemRenderer
                        ? customItemRenderer(selectedOption)
                        : translator(selectedOption)
                    : placeholder || '';
            }
        };

        const text = getText();

        const tooltip = tooltipGenerator(
            hasSelectedValue ? selectedOption : ''
        );

        return this.wrapTooltip({
            visible: Boolean(tooltip),
            title: tooltip,
            content: (
                <S.ComponentWrapper
                    class={className}
                    onClick={(e) => {
                        if (disabled) return;

                        e.stopPropagation();
                        this.$emit('click', e);
                    }}
                    id={id}
                >
                    <S.BoxWrapper
                        class="selected-box"
                        selectedOption={selectedOption}
                        disabled={disabled}
                        uiDisabled={uiDisabled}
                        maxWidth={maxWidth}
                    >
                        <h1>{text}</h1>
                        {arrowIconVisible ? (
                            customArrowIcon ? (
                                customArrowIcon
                            ) : (
                                <Icon
                                    v-view-box
                                    class={[
                                        `arrow-icon`,
                                        { 'is-open': isOpen },
                                    ]}
                                />
                            )
                        ) : null}
                    </S.BoxWrapper>
                </S.ComponentWrapper>
            ),
        });
    },
};
